import { FaStar, FaRegStar } from 'react-icons/fa';
import { FaStarHalfAlt } from 'react-icons/fa'; // half star

export const renderStars = (rating: number, totalStars = 5) => {
  if (!rating || rating < 0) rating = 0;
  const stars = [];
  const fullStars = Math.floor(rating); // whole number
  const hasDecimal = rating % 1 !== 0; // true if has decimal part
  const emptyStars = totalStars - fullStars - (hasDecimal ? 1 : 0);

  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <FaStar key={`full-${i}`} className="xl:text-3xl fill-secondary" />
    );
  }

  if (hasDecimal) {
    stars.push(
      <FaStarHalfAlt key="half" className="xl:text-3xl fill-secondary" />
    );
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <FaRegStar key={`empty-${i}`} className="xl:text-3xl text-gray-300" />
    );
  }

  return stars;
};
